import settings from './settings'
import join from 'lodash/join'
import get from 'lodash/get'
import set from 'lodash/set'
import has from 'lodash/has'
import mergeWith from 'lodash/mergeWith'
import cloneDeep from 'lodash/cloneDeep'

function getScreenshot (num, info) {
  const count = info.screenshots.length
  if (count > 0) {
    const sNum = num % count
    return info.screenshots[sNum]
  } else {
    return ''
  }
}

function getReview (num, info) {
  const count = info.reviews.length
  if (count > 0) {
    const sNum = num % count
    return info.reviews[sNum]
  } else {
    return {}
  }
}

function bytesToSize (bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
}

function createScore (score) {
  const res = ['☆', '☆', '☆', '☆', '☆']
  for (let i = 0; i < score; i++) {
    res[i] = '★'
  }
  return join(res, ' ')
}

function makeReviewText (str) {
  if (str.length > 220) {
     return str.substring(0, 220) + '...'
  }
  return str
}


export function createCustomFields (info, isIos = true) {
  console.log('createCustomFields', info)
  const s = {}
  s.templateId = 'appWebsite'

  const title = get(info, 'title', '')
  const icon = get(info, 'icon', '')

  // SCENE 1
  set(s, 'scene1.title', title)
  set(s, 'scene1.logo', icon)

  // SCENE 2
  set(s, 'scene2.bg', getScreenshot(0, info))
  set(s, 'scene2.text1', 'By ' + get(info, 'developer'))
  set(s, 'scene2.text2', 'Rated ' + get(info, 'contentRating', ''))

  // SCENE 3
  set(s, 'scene3.title', get(info, 'title', ''))
  if (has(info, 'video')) {
    set(s, 'scene3.video', get(info, 'video'))
  } else {
    set(s, 'scene3.video.thumbUrl', icon)
    set(s, 'scene3.video.url', '')
  }
  let description = get(info, 'description', '')
  if (description.length > 220) {
    description = description.substring(0, 220) + '...'
  }
  set(s, 'scene3.description', description)

  // SCENE 4
  set(s, 'scene4.bg', getScreenshot(1, info))
  const review0 = getReview(0, info)
  set(s, 'scene4.title', createScore(review0.score))
  set(s, 'scene4.description', review0.userName)
  set(s, 'scene4.tip', makeReviewText(review0.text))
  set(s, 'scene4.tipIcon', icon)

  // SCENE 5
  set(s, 'scene5.bg', getScreenshot(2, info))
  const review1 = getReview(1, info)
  set(s, 'scene5.title', createScore(review1.score))
  set(s, 'scene5.description', review1.userName)
  set(s, 'scene5.tip', makeReviewText(review1.text))
  set(s, 'scene5.tipIcon', icon)

  // SCENE 6
  set(s, 'scene6.bg', getScreenshot(3, info))
  const review2 = getReview(2, info)
  set(s, 'scene6.title', createScore(review2.score))
  set(s, 'scene6.description', review2.userName)
  set(s, 'scene6.tip', makeReviewText(review2.text))
  set(s, 'scene6.tipIcon', icon)

  // SCENE 7
  set(s, 'scene7.bg', getScreenshot(4, info))
  set(s, 'scene7.img', icon)
  set(s, 'scene7.title', title)
  const desc7 = []
  if (has(info, 'ganre')) desc7.push(`Ganre: ${info.ganre}`)
  if (has(info, 'version')) desc7.push(`Version: ${info.version}`)
  if (has(info, 'size')) desc7.push(`Size: ${bytesToSize(info.size)}`)
  set(s, 'scene7.description', desc7)

  // SCENE 8
  set(s, 'scene8.bg', getScreenshot(5, info))
  set(s, 'scene8.description', title)
  const appLinkPath = isIos ? 'scene8.appLinks.apple' : 'scene8.appLinks.google'
  set(s, appLinkPath, info.url)

  return s
}

export function createSettingsForMobileApp (info, isIos = true) {
  console.log('info', info)
  const customFields = createCustomFields(info, isIos)
  return mergeWith(cloneDeep(settings), customFields)
}



// WEBPACK FOOTER //
// ./src/templates/app-website/template/mobileApp.js